import React from 'react';
import { hasGooglePlayUrl, SITE } from '../config/site';

export default function PlayCta({ className = '', id, label = 'Atsisiųsti iš Google Play' }) {
  if (!hasGooglePlayUrl()) {
    return (
      <span className={`play-cta play-cta-soon ${className}`.trim()} id={id}>
        Netrukus Google Play
      </span>
    );
  }

  return (
    <a
      id={id}
      className={`play-cta play-cta-link ${className}`.trim()}
      href={SITE.googlePlayUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      {label}
    </a>
  );
}
